import { deleteCarrier } from "@/api/carriers/carriers";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { Delete } from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";

interface IProps {
    /**
     * The carrier ID
     */
    carrierId: number;
}

export const DeleteCarrierButton = ({ carrierId }: IProps) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();

    const handleDelete = async () => {
        await dialogs.open(DestructiveDialog, {
            itemId: carrierId,
            subject: "carrier",
            mutationFn: deleteCarrier,
            onSucceeded: () => {
                queryClient.invalidateQueries({
                    queryKey: ["admin-carriers"],
                });
            },
        });
    };

    return (
        <GridActionsCellItem
            icon={<Delete />}
            label="Delete Carrier"
            onClick={handleDelete}
        />
    );
};
